module.exports = __webpack_public_path__ + "static/media/shapes_09.96bb6a36.svg";